import template from "./proxy-response-json.html";
function Controller() {
	const ctrl = this;

	ctrl.$onInit = () => {
		ctrl.parseError = false;
		ctrl.json = null;

		if(ctrl.content === null || ctrl.content === undefined) {
			ctrl.json = null;
			return;
		}

		if(typeof ctrl.content === "object") {
			ctrl.json = ctrl.content;
			return;
		}

		try {
			ctrl.json = JSON.parse(ctrl.content);
		}catch(e) {
			ctrl.parseError = true;
		}
	};
}

export default angular.module("vesl.components.proxy-response-json", []).component("proxyResponseJson", {
	bindings: {
		content: "<"
	},
	controller: Controller,
	template
}).name;
